
































































































import type { Field, MergeValues } from '@getaccept/editor-lib';
import { EditorHelper, FieldInputType, ProsemirrorHelper } from '@getaccept/editor-lib';
import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import type { EditorRecipientInput } from '@getaccept/lib-shared/src/types/editor-recipient-input';
import { useInputFieldView, inputFieldProps } from '../composables/input-field-view.composable';
import { useEditorViewInputStore } from '../store/editor-view-input.store';
import ProsemirrorViewerFormInput from './ProsemirrorViewerFormInput.vue';
import ProsemirrorViewerFormEmailInput from './ProsemirrorViewerFormEmailInput.vue';
import InputDropdown from './InputDropdown.vue';
import InputCheckbox from './InputCheckbox.vue';
import InputDate from './InputDate.vue';

export default defineComponent({
  name: 'InputSetField',
  components: {
    ProsemirrorViewerFormInput,
    ProsemirrorViewerFormEmailInput,
    InputDate,
    InputCheckbox,
    InputDropdown,
  },
  props: {
    ...inputFieldProps,
    mergeValues: { type: Object as PropType<MergeValues>, required: true },
    isPdfViewer: { type: Boolean },
    input: { type: Object as PropType<Field>, default: () => ({}) },
    fields: { type: Array as PropType<Field[]>, default: () => [] },
    editable: { type: Boolean, default: false },
    hasFocus: { type: Boolean, default: false },
    recipientInput: { type: Array as PropType<EditorRecipientInput[]>, required: true },
    failedInputUpdates: { type: Array as PropType<EditorRecipientInput[]>, default: () => [] },
    updatingInputs: { type: Array as PropType<EditorRecipientInput[]>, default: () => [] },
  },
  setup(props, { emit }) {
    const { getTooltip } = useInputFieldView(props);

    const editorViewInputStore = useEditorViewInputStore();

    const updateValue = (payload: { value: string; inputId: string }) => {
      emit('update-value', payload);
    };

    const hasUpdateError = (inputId: string) =>
      props.failedInputUpdates.some(input => input.fieldId === inputId);

    const isUpdatingInputValue = (inputId: string) =>
      props.updatingInputs.some(input => input.fieldId === inputId);

    const handleInputUpdate = (value: string, input: Field) => {
      if (EditorHelper.getTextValue(input, props.recipientInput) === value) {
        return;
      }
      updateValue({ value, inputId: input.id });
    };

    const handleCheckboxUpdate = (value: boolean, inputId: string) => {
      updateValue({ value: value ? '1' : '0', inputId });
    };

    const validateFormInputField = (isValid: boolean) => {
      editorViewInputStore.updateFormInputFieldsWithErrors({ fieldId: props.input.id, isValid });
    };

    return {
      hasUpdateError,
      handleInputUpdate,
      handleCheckboxUpdate,
      isUpdatingInputValue,
      getTextValue: EditorHelper.getTextValue,
      getSafeText: ProsemirrorHelper.getSafeText,
      getInputContent: ProsemirrorHelper.getInputContent,
      getCheckboxValue: EditorHelper.getCheckboxValue,
      getRecipientInputField: EditorHelper.getRecipientInputField,
      FieldInputType,
      getTooltip,
      updateValue,
      validateFormInputField,
    };
  },
});
